"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDispatcherUpdateWarehouseRequest = void 0;
var superstruct_1 = require("superstruct");
var ThirdPartyProviderActiveTime_1 = require("../../types/ThirdPartyProviderActiveTime");
var isStruct_1 = require("../../utils/isStruct");
var DispatcherUpdateWarehouseRequestStruct = (0, superstruct_1.type)({
    warehouseId: (0, superstruct_1.string)(),
    isAutoAssignmentEnabled: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    thirdPartyProviders: (0, superstruct_1.optional)((0, superstruct_1.array)((0, superstruct_1.string)())),
    thirdPartyProviderActiveTimes: (0, superstruct_1.optional)((0, superstruct_1.record)((0, superstruct_1.string)(), (0, superstruct_1.array)(ThirdPartyProviderActiveTime_1.ThirdPartyProviderActiveTimeStruct))),
});
function isDispatcherUpdateWarehouseRequest(obj) {
    return (0, isStruct_1.isStruct)(obj, DispatcherUpdateWarehouseRequestStruct, "DispatcherUpdateWarehouseRequest");
}
exports.isDispatcherUpdateWarehouseRequest = isDispatcherUpdateWarehouseRequest;
